// import React from 'react';
// import { IfmsRoute }from '../../../config/types';

// const opReportSet = React.lazy(() => import('../opReport/opReportSet'));

// const routes:Array<IfmsRoute> = [
//   {path: '/opReport', component: opReportSet},
// ];

// export default routes;
import React from 'react';
import { IfmsRoute }from '../../../config/types';

const DutyPendingsView =  React.lazy(() => import('../../common/reports/DutyPendingsView')); 
const DutyReportView =  React.lazy(() => import('../../common/reports/DutyReportView')); 
const VolumeReportView =  React.lazy(() => import('../../common/reports/VolumeReportView')); 
const VendorCostView =  React.lazy(() => import('../../common/reports/VendorCostView')); 
const ExpenseView =  React.lazy(() => import('../../common/reports/ExpenseView')); 
const OperationPerformanceView =  React.lazy(() => import('../../common/reports/OperationPerformanceView')); 
const IssueReadyView =  React.lazy(() => import('../../common/reports/IssueReadyView')); 
const CustomerActivityView =  React.lazy(() => import('../../common/reports/CustomerActivityView')); 
const BranchPerformanceView =  React.lazy(() => import('../../common/reports/BranchPerformanceView')); 
const ProfitAndVolumeSummaryView =  React.lazy(() => import('../../common/reports/ProfitAndVolumeSummaryView')); 
const ProfitByBillCodeView =  React.lazy(() => import('../../common/reports/ProfitByBillCodeView')); 
const RunQueryView =  React.lazy(() => import('../specialReport/implementation/RunQueryView')); 

const routes:Array<IfmsRoute> = [

   { path: '/opReport/dutyReport', component: DutyReportView },
   { path: '/opReport/dutyPendings', component: DutyPendingsView },
   { path: '/opReport/estProfit', component: ProfitAndVolumeSummaryView },
   { path: '/opReport/issueReady', component: IssueReadyView },
   { path: '/opReport/recogProfit', component: ProfitAndVolumeSummaryView },
   { path: '/opReport/cost', component: VendorCostView },
   { path: '/opReport/expense', component: ExpenseView },
   { path: '/opReport/volume', component: VolumeReportView },
   { path: '/opReport/salesPerformance', component: ProfitAndVolumeSummaryView },
   { path: '/opReport/customerActivity', component: CustomerActivityView },
   { path: '/opReport/opPerformance', component: OperationPerformanceView },
   { path: '/opReport/branchPerformance', component: BranchPerformanceView },
   { path: '/opReport/profitByBillCode', component: ProfitByBillCodeView },
   { path: '/opReport/customize/:id', component: RunQueryView },
];

export default routes;
